import type { ButtonHTMLAttributes, AnchorHTMLAttributes, ReactNode } from 'react';
import { button } from './Button.css';

type Variant = 'primary' | 'outline' | 'ghost' | 'blue' | 'danger' | 'ghostDanger';
type Size = 'md' | 'sm';

interface CommonProps {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  block?: boolean;
}

type ButtonProps =
  | (CommonProps & { href: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'className'>)
  | (CommonProps & { href?: undefined } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'>);

export function Button(props: ButtonProps) {
  const { children, variant = 'primary', size = 'md', block, ...rest } = props;
  const cls = button({ variant, size, block });

  if ('href' in props && props.href !== undefined) {
    const { href, disabled, ...anchorRest } = rest as AnchorHTMLAttributes<HTMLAnchorElement> & { disabled?: boolean };
    return (
      <a className={cls} role="button" href={href} data-variant={variant} data-size={size}
         aria-disabled={disabled || undefined} {...anchorRest}>
        {children}
      </a>
    );
  }
  const buttonRest = rest as ButtonHTMLAttributes<HTMLButtonElement>;
  return (
    <button className={cls} type={buttonRest.type ?? 'button'} data-variant={variant} data-size={size} {...buttonRest}>
      {children}
    </button>
  );
}
